import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const fetchTournamentData =
  (token, page, sort, order, search) => async (dispatch) => {
    dispatch({ type: "FETCH_TOURNAMENT_REQUEST" });

    let reqQuery = `?page=${page}`;
    if (sort) {
      reqQuery += `&sort=${sort}&order=${order}`;
    }
    if (search) {
      reqQuery += `&search=${search}`;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/getAllTournaments${reqQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({ type: "FETCH_TOURNAMENT_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({ type: "FETCH_TOURNAMENT_FAILURE", payload: error.message });
    }
  };
